import { RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import RoutingDefinitions from './RoutingDefinitions';
import FilterUsageLogger from '../infrastructure/FilterUsageLogger';
import { PhdPortalDefinition, PortalDefinitionHelper } from '../models/definition';
import { Routes } from './Routes';
import { BaseRoutes } from './BaseRoutes';
import { ShortCoursesRoutes } from './ShortCoursesRoutes';
import { PortalType } from '@studyportals/domain-client';
import store from '@/study-search/store';
import { IRoutingRegistration } from '@studyportals/search-page-interface';
import { RouteValidatorHandler } from './validators/RouteValidatorHandler';

export class RoutingRegistration implements IRoutingRegistration {
	public readonly routes: RouteRecordRaw[];

	public constructor() {
		this.routes = this.getRoutesRoot(window.PortalType);
	}

	public beforeEach(to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext): void {
		const matched = to.matched.length > 0;
		const rootRoute = this.routes.find((route) => route.name === RoutingDefinitions.ROOT);

		if (!matched && rootRoute) {
			const portalPath = store.getters.getPortalPath();

			next(`/${portalPath}`);
			return;
		}

		FilterUsageLogger.logFilters(to);

		new RouteValidatorHandler().handle(to, next);
	}

	public async afterEach(to: RouteLocationNormalized): Promise<void> {
		RoutingDefinitions.afterEach(to);
		await store.actions.updateSearchResultsFromRoute(to);
	}

	private getRoutesRoot(portalType: PortalType): RouteRecordRaw[] {
		const portalDefinition =
			portalType !== undefined ? new PortalDefinitionHelper().getPortalDefinition(portalType) : PhdPortalDefinition;

		let routes: RouteRecordRaw[] = [];

		if (portalType === PortalType.DISTANCE_LEARNING) {
			routes = new BaseRoutes().getRoutesRoot(portalDefinition);
		} else if (portalType === PortalType.SHORT) {
			routes = new ShortCoursesRoutes().getRoutesRoot(portalDefinition);
		} else {
			routes = new Routes().getRoutesRoot(portalDefinition);
		}

		return routes;
	}
}
